/**
 * Authoritative OpenAppCart application category catalog.
 * Consumed by backend seeding and frontend publish/discover fallbacks.
 */
export type DefaultCategory = {
  name: string;
  slug: string;
};

export const DEFAULT_CATEGORIES: readonly DefaultCategory[] = [
  { name: "Art & Design", slug: "art-design" },
  { name: "Auto & Vehicles", slug: "auto-vehicles" },
  { name: "Beauty", slug: "beauty" },
  { name: "Books & Reference", slug: "books-reference" },
  { name: "Business", slug: "business" },
  { name: "Comics", slug: "comics" },
  { name: "Communication", slug: "communication" },
  { name: "Dating", slug: "dating" },
  { name: "Education", slug: "education" },
  { name: "Entertainment", slug: "entertainment" },
  { name: "Events", slug: "events" },
  { name: "Finance", slug: "finance" },
  { name: "Food & Drink", slug: "food-drink" },
  { name: "Games", slug: "games" },
  { name: "Health & Fitness", slug: "health-fitness" },
  { name: "House & Home", slug: "house-home" },
  { name: "Libraries & Demo", slug: "libraries-demo" },
  { name: "Lifestyle", slug: "lifestyle" },
  { name: "Maps & Navigation", slug: "maps-navigation" },
  { name: "Medical", slug: "medical" },
  { name: "Music & Audio", slug: "music" },
  { name: "News & Magazines", slug: "news" },
  { name: "Parenting", slug: "parenting" },
  { name: "Personalization", slug: "personalization" },
  { name: "Photography", slug: "photography" },
  { name: "Productivity", slug: "productivity" },
  { name: "Shopping", slug: "shopping" },
  { name: "Social", slug: "social" },
  { name: "Sports", slug: "sports" },
  { name: "Tools", slug: "tools" },
  { name: "Travel & Local", slug: "travel" },
  { name: "Video Players & Editors", slug: "video-players-editors" },
  { name: "Weather", slug: "weather" },
  { name: "Web3 & Cryptocurrency", slug: "web3-cryptocurrency" },
  { name: "Other", slug: "other" },
] as const;

export const DEFAULT_CATEGORY_NAMES = DEFAULT_CATEGORIES.map(
  (category) => category.name,
);
